import axios from 'axios';
// Récupérer l'URL de l'API depuis les variables d'environnement
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';
console.log('🔌 API URL:', API_URL);
console.log('📱 Mode:', import.meta.env.VITE_MODE || 'development');
console.log('🐛 Debug:', import.meta.env.VITE_DEBUG === 'true');
const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});
// Interceptor pour ajouter le token et gérer FormData
api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');

    if (config.data instanceof FormData) {
        if (config.headers) {
            delete config.headers['Content-Type'];
            delete config.headers['content-type'];
        }
    }

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});
// Interceptor pour gérer les erreurs
api.interceptors.response.use(response => response, error => {
    if (error.response?.status === 401) {
        localStorage.removeItem('token');
        localStorage.removeItem('userId');
        localStorage.removeItem('userEmail');
        window.location.href = '/';
    }
    return Promise.reject(error);
});
/**
 * Convertit un chemin de fichier en URL accessible via le backend
 * @param filePath - Chemin du fichier (peut être relatif ou URL complète)
 * @returns URL du fichier ou chaîne vide si pas de chemin
 */
export const getFileUrl = (filePath) => {
    if (!filePath)
        return '';
    // Si c'est déjà une URL absolue (http/https), la retourner
    if (filePath.startsWith('http')) {
        return filePath;
    }
    // Si c'est un chemin commençant par /files/, le retourner
    if (filePath.startsWith('/files/')) {
        return filePath;
    }
    // Si c'est un chemin que le backend a retourné (sans /files/), y ajouter le prefix
    if (filePath.startsWith('/')) {
        return filePath;
    }
    // Sinon, ajouter /files/ au début
    return `/files/${filePath}`;
};
export default api;
//# sourceMappingURL=api.js.map